<template>
  <div class="row user-actions-controls">
    <div class="col-12">
      <el-button
        type="primary" plain
        disabled
        @click="$emit('command', 'download-customer-po-open')"
        :style="{ width: '100%' }"
      >
        {{L10n('download-customer-po-open')}}
      </el-button>
    </div>
    <div class="col-12">
      <el-button
        type="primary" plain
        @click="$emit('onCreateInvoice')"
        :style="{ width: '100%' }"
      >
        {{L10n('create-invoice')}}
      </el-button>
    </div>
    <div class="col-12">
      <el-button
        type="primary" plain
        @click="$emit('onShowCustomerReminder')"
        :style="{ width: '100%' }"
      >
        {{L10n('show-customer-reminder')}}
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserActions'
}
</script>

<style lang="stylus">
  .user-actions-controls{
    button {
      margin 1rem 0
    }
  }
</style>
